<header class="header" id="header">
  <button class="sidenav-trigger" mat-icon-button aria-label="Open navigation" (click)="toggleDrawer()">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="logo pull-left">
    <a [routerLink]="['user/login']">
      <img src="assets/img/glasswing_logo.svg">
    </a>
  </div>

  <div class="headerSearchBar headerSearchBar1" *ngIf="user?.roles_id == 3 && !advanceSearchFlag">
    <input type="text" class="form-searchbar" [(ngModel)]="inputSearch" (keydown)="getSerachData($event)"
      placeholder="Search">
    <span class="search-btn"><i class="ti-search"></i> </span>

    <button mat-raised-button (click)="onClickAdvanceSearch()" class="confirm_btn blueButton saveButton">Advance
      Seach</button>
  </div>

  <div class="headerSearchBar advsearch" *ngIf="user?.roles_id == 3 && advanceSearchFlag">
    <button mat-raised-button (click)="onClickAdvanceSearch()" class="advSeachBtn"> <span
        style="font-weight: bold;font-size: 15px;margin-right: 6px;">
    </span> Advance Seach</button>

    <mat-form-field class="mat-form-field" style="margin: 0px 20px;">
      <mat-select placeholder="Origin" [(value)]="selected">
        <!--  (selectionChange)="selectId()" (click)="setTouchedSelf()" (keyup)="setTouchedSelf()" -->
        <mat-option *ngFor="let element of list" [value]="element.id">{{element.name || element.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="mat-form-field" style="margin-right: 20px;">
      <mat-select placeholder="Destination" [(value)]="selected">
        <!--  (selectionChange)="selectId()" (click)="setTouchedSelf()" (keyup)="setTouchedSelf()" -->
        <mat-option *ngFor="let element of list" [value]="element.id">{{element.name || element.name}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="mat-form-field">
      <mat-select placeholder="Date Range" [(value)]="selected">
        <!--  (selectionChange)="selectId()" (click)="setTouchedSelf()" (keyup)="setTouchedSelf()" -->
        <mat-option *ngFor="let element of list" [value]="element.id">{{element.name || element.name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- <div class="advancesearchbox"  *ngIf="user?.roles_id == 3" (click)="getSerachData()"><span class="addSearch">Search</span></div> -->

  <div class="rightUserSec ">
    <div class="notificationSection notificationSection-plus"
      *ngIf="userCanCreateOrder && (user?.roles_id == 1 || user?.roles_id == 10)">
      <!-- <div class="notificationSection"> -->
      <button mat-button class="blueButton newOrdBtn " (click)="createBooking()">
        <span class="btnBorder nOrdBtn">
          Create Order</span>
      </button>
    </div>
    <div class="headerCell">
      <div class="notificationSection">
        <button class="userIcon" mat-icon-button [matMenuTriggerFor]="menu" (click)="notificationClick()"
          (click)="notificationClick()" [matBadge]="notificationLength()" matBadgePosition="after"
          matBadgeColor="accent">
          <img src="assets/img/new icons/notification.svg" alt="" class="header_img">
        </button>
        <!-- <button mat-icon-button [matMenuTriggerFor]="menu" (click)="notificationClick()" class="userIcon">
        <mat-icon class="icon_bell" [matBadge]="notificationLength()" matBadgePosition="above after"
          [matBadgeColor]="badgeColor" style="margin-top: 8px;">
          <img src="assets/img/new icons/notification.svg" alt="" class="header_img not__icon" style="margin-top: -9px;">
        </mat-icon>
      </button> -->
        <mat-menu #menu="matMenu" class="notificationMenuBox">
          <div class="listview p-2">
            <div class="lv-header">Notifications</div>
            <!-- *ngFor="let notification of notificationsList;let i=index " -->
            <div class="lv-body" *ngFor="let notification of notificationsList;let i=index ">
              <a class="listData" *ngIf="i < 3">
                <div *ngIf="notification">
                  <div class="textSec">
                    <small class="lv-small"> {{notification.data.message}} </small>
                  </div>
                </div>
              </a>
            </div>
            <div class="clearfix"></div>
            <a class="lv-footer" [routerLink]="['notifications/list']">View All Notifications</a>
          </div>
        </mat-menu>
      </div>
    </div>
    <!-- <button class="flag" mat-icon-button [matMenuTriggerFor]="language">
         <div class="flag-pic">
           <img src="assets/img/eng.svg" alt="user">
         </div>
      </button> -->
    <!-- <mat-menu #language="matMenu">
      <div class="dropdown-menu dropdown-menu-right">
        <a class="dropdown-item" href="#">
          <img src="assets/img/india.svg" alt="user">
        Hindi</a>
        <a class="dropdown-item" href="#"><i class="flag-icon flag-icon-us"></i> English</a>
      </div>
      </mat-menu>  -->
    <div class="notificationSection">
      <button class="userIcon" mat-icon-button [matMenuTriggerFor]="settingsMenu" aria-label="Display settings">
        <img src="assets/img/new icons/settings.svg" alt="" class="header_img">
      </button>
    </div>
    <div class="notificationSection">
      <button class="avatar-btn" mat-icon-button [matMenuTriggerFor]="userProfileMenu" aria-label="User menu">
        <span class="avatar-initials">{{ userInitials }}</span>
      </button>
    </div>
    <!-- <div class="notificationSection">
      <button class="userIcon" mat-icon-button (click)="fontSizeIncrease()">
        <mat-icon>text_increase</mat-icon>
      </button>
    </div> -->
    <mat-menu #settingsMenu="matMenu" class="settings-menu">
      <button mat-menu-item (click)="fontSizeIncrease()">
        <mat-icon>text_increase</mat-icon>
        <span>Increase text size</span>
      </button>
      <button mat-menu-item (click)="fontSizeDecrease()">
        <mat-icon>text_decrease</mat-icon>
        <span>Decrease text size</span>
      </button>
      <button mat-menu-item (click)="fontWeightIncrease()">
        <mat-icon>line_weight</mat-icon>
        <span>Increase weight</span>
      </button>
    </mat-menu>

    <mat-menu #userProfileMenu="matMenu" class="userProfileMenuBox user-menu">
      <div class="user-menu-header">
        <span class="avatar-initials lg">{{ userInitials }}</span>
        <div class="user-meta">
          <div class="user-name">{{ user?.name }}</div>
          <div class="user-company">{{ getCompanyName() }}</div>
        </div>
      </div>
      <button mat-menu-item (click)="logout()">
        <mat-icon>power_settings_new</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
    <!-- </div>
  <div class="rightUserSec headerRightActions"> -->

  </div>
</header>
